import favoritesStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export const setCombinedFavoriteIdsInStoreMutator: (favoriteIds: string[]) => void = mutatorAction(
    'setCombinedFavoriteIdsInStore',
    (favoriteIds: string[]): void => {
        favoritesStore().orderedCombinedOutlookFavoritesIds = favoriteIds;
    }
);
